export default __webpack_public_path__ + "static/media/hostaway_step5.d45c6725.jpg";